export default __webpack_public_path__ + "assets/india-flag.png";